import React, { useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Pokemon from "./components/Pokemon";
import PokemonDesk from "./components/PokemonDesk";
import {
  Paper,
  createMuiTheme,
  Switch,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";

function App() {
  const [DarkMode, setDarkMode] = useState(true);

  // const HandleDark = () => {
  //   setDarkMode(!DarkMode);
  // };

  // const light = "#fff";
  const DarkTheme = createMuiTheme({
    palette: {
      type: "dark",
      primary: green,
      secondary: green,
      // type: !DarkMode ? "light" : "dark",
    },
  });
  const lightTheme = createMuiTheme({
    palette: {
      type: "light",
    },
  });

  return (
    <Router>
      <ThemeProvider theme={DarkMode ? DarkTheme : lightTheme}>
        <Paper style={{ minHeight: "100vh" }} square>
          <Typography
            style={{ marginLeft: "3vw" }}
            variant="span"
            color="secondary"
          >
            Change Theme Mode
          </Typography>
          <Switch
            color="secondary"
            checked={DarkMode}
            // onChange={HandleDark}
            onChange={() => setDarkMode(!DarkMode)}
          />
          <Route
            path="/"
            exact={true}
            component={() => (
              <PokemonDesk darkModeVal={DarkMode} darkModeFunc={setDarkMode} />
            )}
          />
          <Route path="/:id" component={Pokemon} />
        </Paper>
      </ThemeProvider>
    </Router>
  );
}

export default App;
